import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { Icons } from './Icons';
import './SettingsPanel.css';

export default function TemplatesPanel({ onClose }) {
  const { currentUser, userProfile, setUserProfile } = useAuth();
  const toast = useToast();
  const [templates, setTemplates] = useState(
    userProfile?.templates || [
      { label: 'Cold Email', content: '' },
      { label: 'Follow Up', content: '' },
      { label: 'Thank You', content: '' },
      { label: 'Networking', content: '' },
      { label: 'Custom', content: '' }
    ]
  );
  const [quickNotes, setQuickNotes] = useState(userProfile?.quickNotes || '');
  const [saving, setSaving] = useState(false);
  const [editingLabel, setEditingLabel] = useState(null);

  function updateTemplate(index, field, value) {
    setTemplates(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  }

  async function handleSave() {
    setSaving(true);
    try {
      await updateDoc(doc(db, 'users', currentUser.uid), {
        templates,
        quickNotes
      });
      setUserProfile(prev => ({ ...prev, templates, quickNotes }));
      toast('Templates & notes saved');
    } catch (err) {
      toast(err.message, 'error');
    }
    setSaving(false);
  }

  return (
    <div className="panel-overlay" onClick={onClose}>
      <div className="panel slide-up" onClick={e => e.stopPropagation()}>
        <div className="panel-header">
          <h2>Templates & Notes</h2>
          <button className="panel-close" onClick={onClose}><Icons.X size={18} /></button>
        </div>

        <div className="panel-body">
          <p className="settings-desc" style={{ marginBottom: 20 }}>
            Templates and quick notes are private and only visible to you. They are never shared with anyone.
          </p>

          {/* Templates */}
          <section className="settings-section">
            <h3>Message Templates (5)</h3>
            {templates.map((tpl, i) => (
              <div key={i} className="template-block">
                <div className="template-label-row">
                  {editingLabel === i ? (
                    <input
                      autoFocus
                      className="template-label-input"
                      value={tpl.label}
                      onChange={e => updateTemplate(i, 'label', e.target.value)}
                      onBlur={() => setEditingLabel(null)}
                      onKeyDown={e => { if (e.key === 'Enter') setEditingLabel(null); }}
                      maxLength={30}
                    />
                  ) : (
                    <span className="template-label" onClick={() => setEditingLabel(i)}>
                      {tpl.label || `Template ${i + 1}`}
                      <Icons.Edit size={11} />
                    </span>
                  )}
                </div>
                <textarea
                  value={tpl.content}
                  onChange={e => updateTemplate(i, 'content', e.target.value)}
                  placeholder={`Write your ${tpl.label || 'template'} message here...`}
                  rows={4}
                />
              </div>
            ))}
          </section>

          {/* Quick Notes */}
          <section className="settings-section">
            <h3>Quick Notes</h3>
            <p className="settings-desc">Personal scratchpad for job search notes, reminders, or anything else.</p>
            <textarea
              className="quick-notes-textarea"
              value={quickNotes}
              onChange={e => setQuickNotes(e.target.value)}
              placeholder="Write your notes here..."
              rows={8}
            />
          </section>
        </div>

        <div className="panel-footer">
          <button className="panel-save-btn" onClick={handleSave} disabled={saving}>
            {saving ? <span className="loading-spinner" /> : 'Save Templates & Notes'}
          </button>
        </div>
      </div>
    </div>
  );
}
